import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NavigateContext, M_Table, LoadingContext } from 'src/M_Components'

export const AgreementList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const [selectedLines, setSelectedLines] = useState([])
    const [refresh, setRefresh] = useState(false)

    const onPassContext = (e) => {
        if (e) sessionStorage.setItem('context', JSON.stringify(e))
    }

    const NewRoute = (url, label, operation, data) => {
        if (data) {
            ctx.passValue?.set('operation', operation)
            ctx.passValue?.set('row', data)
            ctx2.newTab(url, label)
        }
    }

    return (
        <M_Table
            entityName={'agreement'}
            rolePermissions={roles}
            tablesOrder={tablesOrder}
            onTablesOrderUpdate={onTablesOrderUpdate}
            pageUrl={'agreement'}
            removeContextItems={['Print', 'View', 'Copy']}
            onPassLine={(lines) => {
                setSelectedLines(lines)
                if (lines) sessionStorage.setItem('lines', JSON.stringify(lines))
            }}
            replaceFunctions={new Map([
                ['Create', (data) => NewRoute('go/agreementDetail', t('CreateAgreement'), 'create', {})],
                ['Edit', (data) => NewRoute('go/agreementDetail', t('EditAgreement'), 'edit', data)]
            ])}
            onPassContext={onPassContext}
            refresh={refresh}
            setRefresh={setRefresh}
        />
    )
}
